export default "__VITE_ASSET__hk5hD6ZO__"